import React, { Component } from 'react'
import { List } from 'material-ui/List'
import { Card, CardText } from 'material-ui/Card'
import { Subheader } from 'material-ui'

export class DealDetails extends Component {
  render() {
    const details = this.props.details
    const items = details.map((item, idx) => {
      const subscriptions = item.subscriptions
        ? item.subscriptions.map((subscription, idx) => {
            return (
              <div className='col-xs-6 col-md-4 col-lg-3' key={idx}>
                <Card>
                  <CardText>
                    <div>
                      <label>Name</label>:<span>{subscription.name}</span>
                    </div>
                    <div>
                      <label>Start Date</label>:
                      <span>{subscription.start_date}</span>
                    </div>
                    <div>
                      <label>Duration (Days)</label>:
                      <span>{subscription.duration_in_days}</span>
                    </div>
                  </CardText>
                </Card>
              </div>
            )
          })
        : []
      return (
        <div key={idx} className='container-fluid row'>
          <List>
            <Subheader>
              {`${idx + 1}.`} Package Name: {item.name}
            </Subheader>
            {subscriptions.length ? (
              <div className='col-xs-12 text-dull'>Subscriptions:</div>
            ) : (
              ''
            )}
            {subscriptions}
          </List>
        </div>
      )
    })
    return <div>{items}</div>
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/DealDetails.js
 **/